import { NgModule } from "@angular/core";
import { UiMenuGroupComponent } from "./components/menu-group/menu-group.component";
import { UiMenuItemComponent } from "./components/menu-item/menu-item.component";
import { UiSubmenuInlineChildComponent } from "./components/submenu-inline-child/submenu-inline-child.component";
import { UiSubmenuNoneInlineChildComponent } from "./components/submenu-non-inline-child/submenu-non-inline-child.component";
import { UiSubmenuTitleComponent } from "./components/submenu-title/submenu-title.component";
import { UiSubmenuComponent } from "./components/submenu/submenu-component";
import { UiMenuDividerDirective } from "./directives/menu-divider-directive";
import { UiMenuDirective } from "./menu.directive";

@NgModule({
  imports: [
    UiMenuDirective,
    UiMenuItemComponent,
    UiSubmenuComponent,
    UiMenuDividerDirective,
    UiMenuGroupComponent,
    UiSubmenuTitleComponent,
    UiSubmenuInlineChildComponent,
    UiSubmenuNoneInlineChildComponent,
  ],
  exports: [UiMenuDirective, UiMenuItemComponent, UiSubmenuComponent, UiMenuDividerDirective, UiMenuGroupComponent],
})
export class UiMenuModule {}
